import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/Button";
import { ReactComponent as ChevronLeftIcon } from "../../../assets/icons/chevron-left.svg";

function BadgeProgressView({ progressPercentage, xpProgress, nextSubTierLabel }: { progressPercentage: number, xpProgress: any, nextSubTierLabel?: string | null }) {
    
    return (
        <div className="flex flex-col mt-3">
            <div className="text-sm font-semibold text-black">XP {xpProgress?.total_xp || 0}/{xpProgress?.current_sub_tier_max || 0}</div>
            <div className="flex items-center gap-4">
                <div
                    className={`flex-1 flex-1 h-[9px] overflow-hidden rounded-full bg-[#ECF4EF]`}
                >
                    <div
                        className={`h-[9px] rounded-full bg-green-700`}
                        style={{
                            width: `${progressPercentage || 0}%`,
                        }}
                    />
                </div>
                <span className="text-sm text-black">{nextSubTierLabel ?? "--"}</span>
            </div>
        </div>
    )
}

export function BadgeCurrentStatus({ xpProgress, isLocked, onViewTierProgression }: { xpProgress: any, isLocked: boolean, onViewTierProgression: () => void }) {
    const navigate = useNavigate();
    const handleGoToPraxisPlay = () => {
        navigate("/praxisplay/role-play");
    }
    const totalXPPoints = xpProgress?.current_sub_tier_max || 0;
    const currentXPPoints = xpProgress?.total_xp || 0;
    const progressPercentage = (currentXPPoints / totalXPPoints) * 100;
    const nextSubTierLabel = xpProgress?.tier_name && xpProgress?.sub_tier_label ? `${xpProgress?.tier_name} ${xpProgress?.sub_tier_label}` : null;
    return (
        <div className="flex justify-between items-center p-[18px] bg-white shadow-[0_2.957px_2.957px_0_rgba(203,90,90,0.05)] rounded-[10px]">
            <div className="flex flex-col gap-1 flex-1">
                <div className="flex justify-between gap-2 items-center">
                    <div className="text-lg font-bold text-black">
                        You're a <span className="text-green-700">{xpProgress?.last_earned_title || "--"}</span>
                    </div>
                    {!isLocked && <button onClick={onViewTierProgression} className="text-base text-black flex items-center gap-1 hover:opacity-70">
                        View Tier Progression <ChevronLeftIcon className="w-6 h-6 rotate-[180deg]" />
                        </button>}
                </div>
                <span className="text-base text-black">{isLocked ? "Complete 1 Game Mode session to unlock the Badge Center" : xpProgress?.tier_subtext || "--"}</span>
                <BadgeProgressView progressPercentage={progressPercentage} xpProgress={xpProgress} nextSubTierLabel={nextSubTierLabel} />
            </div>
            {isLocked && <div>
                <Button variant="primary" className="!h-11 !rounded-full" onClick={handleGoToPraxisPlay}>
                    Go to PraxisPlay
                </Button>
            </div>}

        </div>
    )
}